import { FC, useRef } from 'react';
import classNames from 'classnames/bind';
import styles from './Field.module.scss';

const cx = classNames.bind(styles);

type FieldProps = {
  placeholder?: string;
  title?: string | number | null;
  width?: boolean;
  style?: React.CSSProperties;
  styleTitle?: React.CSSProperties;
  price?: string | number;
  error?: boolean;
};

export const Field: FC<FieldProps> = ({
  placeholder,
  title,
  width,
  style = { width: '314px', minHeight: '40px' },
  price,
  styleTitle = { minHeight: '40px' },
  error = false,
}) => {
  const placeholderRef = useRef<HTMLSpanElement>(null);

  const classNamefield = cx({
    field: true,
    focus: true,
    field_width: width,
  });

  const classNamePlaceholder = cx({
    placeholder: true,
  });
  return (
    <div
      style={
        error
          ? { ...style, border: '1px solid #e10d0d', borderRadius: '4px' }
          : { ...style, border: '1px solid #EAF0FD' }
      }
      className={styles.root}>
      <div
        style={error ? { ...styleTitle, color: '#e10d0d' } : styleTitle}
        className={classNamefield}>
        {title}
      </div>
      {placeholder ? (
        <span className={classNamePlaceholder} ref={placeholderRef}>
          {placeholder}
        </span>
      ) : null}
      {price && (
        <span style={error ? { color: '#e10d0d' } : {}} className={styles.price}>
          {price}
        </span>
      )}
    </div>
  );
};
